

export const getSocialAuthGoogleIdToken = (data) => data.tokenId;